import { TZDate, tz } from '@date-fns/tz';
import { enUS } from 'date-fns/locale';

/**
 * Returns the current date and time adjusted to the specified `timeZone`.
 * If `timeZone` is provided, a `TZDate` instance is returned; otherwise, the system's local time is used.
 *
 * @returns {Date | TZDate} The current date in the specified time zone, or the local system time if no time zone is set.
 */
export function getConvertedDate(timeZone?: string): Date | TZDate {
  if (timeZone) {
    return new TZDate(new Date(), timeZone);
  }
  return new Date();
}

//Type return
export { TZDate };

/**
 * Define the return type for the getTimezoneConfig function
 */
export interface TimezoneConfig {
  in: (value: string | number | Date) => Date | TZDate;

  locale: typeof enUS; // Locale is the enUS object from date-fns
}

/**
 *  method to get timezone configuration
 */
export function getTimezoneConfig(timeZone?: string): TimezoneConfig {
  return {
    in: tz(timeZone ?? new Date().toString()),
    locale: enUS // Set locale to enUS
  };
}
